document.addEventListener('DOMContentLoaded', function() {
  // Simple approach - use innerHTML with regular expressions to reliably add line breaks
  function fixProductDescription() {
    // Get all product descriptions and accordion contents
    const descriptions = document.querySelectorAll('.product__description, .accordion__content');
    
    descriptions.forEach(function(description) {
      // Get all paragraphs inside
      const paragraphs = description.querySelectorAll('p');
      
      paragraphs.forEach(function(paragraph) {
        // Only process paragraphs that might contain our target keywords
        const html = paragraph.innerHTML;
        if (html.includes('Koukut:') || html.includes('Mitat:')) {
          // Create a temporary div to manipulate the HTML safely
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          // Create text nodes and elements for "Koukut:" and "Mitat:"
          const htmlContent = tempDiv.innerHTML;
          
          // Simple string manipulation to replace the target patterns
          let newHTML = htmlContent;
          
          // If "Koukut:" isn't at the start of paragraph, put it on a new line
          if (newHTML.indexOf('<strong>Koukut:</strong>') > 0) {
            newHTML = newHTML.replace(
              /([^>])(\s*<strong>Koukut:<\/strong>)/g,
              '$1<br>$2'
            );
          }
          
          // If "Mitat:" isn't at the start of paragraph, put it on a new line
          if (newHTML.indexOf('<strong>Mitat:</strong>') > 0) {
            newHTML = newHTML.replace(
              /([^>])(\s*<strong>Mitat:<\/strong>)/g,
              '$1<br>$2'
            );
          }
          
          // Update the paragraph content if we made changes
          if (newHTML !== htmlContent) {
            paragraph.innerHTML = newHTML;
          }
        }
      });
    });
  }
  
  // Run the function now
  fixProductDescription();
  
  // Also run after a slight delay to catch any dynamic content
  setTimeout(fixProductDescription, 500);
});
